import React, { useState, useEffect } from "react";
import { motion, AnimatePresence, delay } from "framer-motion";
import "./partTwo.scss";
import { zipImages } from "../../../untils/until";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { message } from "antd";

interface PartOneProps {
  // scrollPosition: number; // 新增属性用于接收滚动位置
  // mobile: boolean;//是否是移动端
}

const PartTwo: React.FC<PartOneProps> = ({ }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const wrapperWidth = window.innerWidth * 0.4
  const wrapperHeight = window.innerHeight * 0.5

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
    },
  };

  const leftVariants = {
    hidden: { opacity: 0, x: -window.innerWidth / 2 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.5,
        delay: 1,
      },
    },
    exit: (direction: any) => ({
      opacity: 0,
      x: -window.innerWidth / 2,
      transition: {
        duration: 1,
        // delay: direction > 0 ? 0 : 0.25 // 方向不同时延迟不同
      },
    }),
  };

  const rightVariants = {
    hidden: { opacity: 0, x: window.innerWidth / 2 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.5,
        delay: 1,
      },
    },
    exit: (direction: any) => ({
      opacity: 0,
      x: window.innerWidth / 2,
      transition: {
        duration: 1,
        // delay: direction > 0 ? 0 : 0.25 // 方向不同时延迟不同
      },
    }),
  };

  const ipConfig = {
    maxOffset: 20,
    outside: {
      width: 683,
      height: 725,
    },
    inside: {
      width: 413,
      height: 524,
    },
    images: [
      {
        src: zipImages("https://oss.tnworld.cn/eastern/assets/jtl/test.jpg"),
        x: -45,
        y: -72,
        width: 501,
        height: 668
      }
    ]
  };

  const top = (ipConfig.outside.height - ipConfig.inside.height) / 2
  const left = 0
  // const left = (ipConfig.outside.width - ipConfig.inside.width) / 2
  // const top = (ipConfig.outside.height - ipConfig.inside.height) / 2
  // const zoom = (window.innerHeight * 0.5) / ipConfig.inside.height



  // 计算图片偏移量
  const getImageOffset = () => {
    // 计算鼠标在容器中的相对位置 (0到1之间)
    const container = document.querySelector('.ip-wrapper');
    if (!container) return { x: 0, y: 0 };

    const rect = container.getBoundingClientRect();
    const relativeX = (mousePosition.x - rect.left) / rect.width;
    const relativeY = (mousePosition.y - rect.top) / rect.height;

    // 计算偏移量 (可以根据需要调整乘数来控制移动幅度)
    const offsetX = -(relativeX - 0.5) * ipConfig.maxOffset; // 40是最大偏移量
    const offsetY = -(relativeY - 0.5) * ipConfig.maxOffset;

    return { x: offsetX, y: offsetY };
  };

  const { x: offsetX, y: offsetY } = getImageOffset();

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    // 只在悬停时监听鼠标移动
    if (isHovering) {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isHovering]);

  const goAnyWhere = (e:any) => {
    e.stopPropagation();
    navigate('/scene?scene=jingtailan');
    // message.warning("敬请期待")
  }


  return (
    <>
      {/* PC */}

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="part-content part2"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <motion.div
          variants={leftVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="half-box"
        >
          <div className="ip-intro">
            <div className="title">{i18n.t(`home_jing_title`)}</div>
            <div className="sub-title">JING TAI LAN</div>
            <div className="introduction">
              {i18n.t('home_jing_des').split('\n')[0]} <br />
              {i18n.t('home_jing_des').split('\n')[1]} <br />
              {i18n.t('home_jing_des').split('\n')?.[2]} <br />
              {i18n.t('home_jing_des').split('\n')?.[3]}
            </div>
            <div className="btn" onClick={(e) => { goAnyWhere(e) }} style={{ backgroundImage: `url(${zipImages('https://oss.tnworld.cn/eastern/assets/btn-bg.png')})` }}>{i18n.t(`home_enter_btn`)}</div>
          </div>
        </motion.div>

        <motion.div
          variants={rightVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="half-box"
        >
          <div className="ip-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" style={{ transform: `translate(${left}px, ${top}px)` }} width={ipConfig.outside.width} height={ipConfig.outside.height} viewBox={`0 0 ${ipConfig.outside.width} ${ipConfig.outside.height}`} fill="none">
              <defs>
                {/* 内阴影滤镜*/}
                <filter id="filter0_f_388_1729" x="-24" y="-28.6582" width="469" height="581.317" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="14" result="effect1_foregroundBlur_388_1729" />
                </filter>

                {/* 外阴影滤镜*/}
                <filter id="filter0_dddddd_388_1185" x="0.322334" y="0.00784659" width="682.334" height="724.666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="3.17882" dy="1.86433" />
                  <feGaussianBlur stdDeviation="1.92824" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.052963 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_388_1185" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="13.9868" dy="8.20304" />
                  <feGaussianBlur stdDeviation="3.99259" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0863704 0" />
                  <feBlend mode="normal" in2="effect1_dropShadow_388_1185" result="effect2_dropShadow_388_1185" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="34.3312" dy="20.1347" />
                  <feGaussianBlur stdDeviation="7.9625" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
                  <feBlend mode="normal" in2="effect2_dropShadow_388_1185" result="effect3_dropShadow_388_1185" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="66.1194" dy="38.778" />
                  <feGaussianBlur stdDeviation="15.6074" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13363 0" />
                  <feBlend mode="normal" in2="effect3_dropShadow_388_1185" result="effect4_dropShadow_388_1185" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="111.259" dy="65.2515" />
                  <feGaussianBlur stdDeviation="28.6968" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.167037 0" />
                  <feBlend mode="normal" in2="effect4_dropShadow_388_1185" result="effect5_dropShadow_388_1185" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dx="171.656" dy="100.674" />
                  <feGaussianBlur stdDeviation="49" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0" />
                  <feBlend mode="normal" in2="effect5_dropShadow_388_1185" result="effect6_dropShadow_388_1185" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect6_dropShadow_388_1185" result="shape" />
                </filter>

                {/* 图形路径，外阴影路径 */}
                <path id="main-shape" d="M392.665 195.427C377.383 174.463 355.307 162.768 331.411 153.85C315.163 147.793 298.668 140.53 287.963 126.319C277.333 112.221 274.666 93.8469 274.741 76.5662C274.762 72.5342 275.088 68.5096 275.715 64.5266C279.7 39.2719 296.817 14.9755 322.909 9.60712C327.141 8.73859 327.815 5.67627 326.602 2H87.3984C86.1849 5.67627 86.8591 8.73859 91.099 9.60712C117.19 14.9755 134.307 39.2719 138.292 64.5266C138.92 68.5096 139.245 72.5342 139.266 76.5662C139.341 93.8469 136.674 112.221 126.045 126.319C115.332 140.545 98.8372 147.793 82.5967 153.85C58.6779 162.768 36.6168 174.433 21.3351 195.427C6.24073 216.175 0.150535 242.56 1.0944 267.942C2.54766 306.816 15.0876 335.223 27.9048 359.819C40.2425 383.494 64.401 422.136 109.474 458.726C104.025 463.494 98.9625 468.687 94.3351 474.255C85.4957 484.917 84.3046 490.068 83.6005 491.91C81.9599 496.178 81.4131 501.112 83.3682 505.238C93.7508 527.033 206.97 524.907 206.97 526C206.97 524.907 320.219 527.033 330.572 505.238C332.527 501.112 331.98 496.178 330.34 491.91C329.635 490.068 328.444 484.917 319.605 474.255C314.997 468.689 309.954 463.497 304.526 458.726C349.599 422.173 373.758 383.531 386.095 359.856C398.912 335.261 411.452 306.854 412.906 267.98C413.849 242.56 407.759 216.175 392.665 195.427Z" />
                {/* 内阴影路径 */}
                <path id="inner-shadow" d="M317.654 4.3418C293.504 13.1172 278.25 37.1232 274.443 61.2461L274.442 61.248C273.774 65.4896 273.428 69.7756 273.405 74.0693V74.0732C273.329 91.7588 276.018 111.532 287.667 126.983V126.982C299.357 142.501 317.18 150.186 333.466 156.258C357.092 165.075 378.116 176.364 392.572 196.195V196.196C406.903 215.896 412.823 241.174 411.909 265.803C410.493 303.693 398.305 331.396 385.596 355.787C373.445 379.105 349.619 417.236 305.112 453.333L300.514 457.063L304.962 460.972C310.206 465.579 315.075 470.596 319.526 475.973L319.529 475.975C323.778 481.1 326.082 484.774 327.386 487.267C328.7 489.78 328.983 490.999 329.469 492.269L329.472 492.277C330.853 495.872 331.002 499.277 329.855 501.699C329.281 502.909 327.597 504.625 323.844 506.489C320.223 508.287 315.344 509.895 309.473 511.297C297.751 514.096 282.892 515.889 268.137 517.05C253.424 518.208 239.008 518.724 228.233 519.019C222.938 519.163 218.295 519.26 215.226 519.348C213.664 519.392 212.369 519.438 211.448 519.493C211.126 519.512 210.787 519.536 210.47 519.568C210.152 519.536 209.813 519.512 209.491 519.493C208.571 519.438 207.277 519.392 205.716 519.348C202.647 519.26 198.006 519.163 192.711 519.019C181.939 518.724 167.525 518.208 152.814 517.05C138.061 515.889 123.203 514.096 111.479 511.297C105.607 509.895 100.727 508.287 97.1035 506.488C93.3532 504.627 91.6649 502.912 91.085 501.699C89.9388 499.277 90.0862 495.872 91.4678 492.277L91.4717 492.269C91.9569 490.999 92.24 489.779 93.5537 487.267C94.8567 484.775 97.1605 481.103 101.407 475.979C105.877 470.601 110.767 465.585 116.03 460.979L120.494 457.073L115.89 453.334C71.3812 417.199 47.555 379.067 35.4043 355.749H35.4033C22.8926 331.739 10.8881 304.52 9.16504 267.534L9.09082 265.766C8.17662 241.175 14.0965 215.896 28.4277 196.196L28.4268 196.195C42.4304 176.956 62.5827 165.79 85.332 157.093L87.542 156.259C103.818 150.188 121.644 142.517 133.342 126.98C144.989 111.529 147.678 91.7578 147.602 74.0732V74.0693L147.594 73.2646C147.535 69.2402 147.191 65.2246 146.564 61.248V61.2461C142.758 37.1232 127.504 13.1173 103.354 4.3418H317.654Z" stroke="black" strokeOpacity="0.8" strokeWidth="10" />

                {/* 图形蒙版 */}
                <mask id="svgmask">
                  <use href="#main-shape" fill="white" />
                </mask>
              </defs>

              {/* 外阴影滤镜 */}
              <use href="#main-shape" filter="url(#filter0_dddddd_388_1185)" fill="rgba(0,0,0,0.1)" />

              {/* 图片 */}
              <image x={ipConfig.images[0].x + offsetX} y={ipConfig.images[0].y + offsetY} width={ipConfig.images[0].width} height={ipConfig.images[0].height} xlinkHref={ipConfig.images[0].src} mask="url(#svgmask)" />

              {/* 内阴影滤镜 */}
              <use href="#inner-shadow" filter="url(#filter0_f_388_1729)" mask="url(#svgmask)" />
            </svg>
          </div>
        </motion.div>
      </motion.div>
      {/* Mobile */}
    </>
  );
};

export default PartTwo;